import { Component, Input } from '@angular/core'

@Component({
  selector: 'app-identificator-common-view',
  templateUrl: './order-identificator-common-view.component.html',
  styleUrls: ['./order-identificator-common-view.component.scss'],
})
export class OrderIdentificatorCommonViewComponent {
  @Input() uuid: string;
}
